import { HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
/**
 * From ChatGPT: The code aims to filter out any query parameters from the HTTP
 * request that are either null or empty strings, and then pass the modified
 * request forward.
 */
export class ClearInterceptorService {
    constructor() { }
    intercept(request, next) {
        const params = {};
        request.params.keys().forEach(value => request.params.get(value) == null || request.params.get(value) === '' ? undefined
            : params[value] = String(request.params.get(value)));
        const reqClone = request.clone({ params: new HttpParams({ fromObject: params }) });
        return next.handle(reqClone);
    }
}
ClearInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClearInterceptorService_Factory() { return new ClearInterceptorService(); }, token: ClearInterceptorService, providedIn: "root" });
